import styled from '@mui/styled-engine';
import { HEX_COLORS } from 'constants/stylesVariables';

export const StyledEmailText = styled('span')(
  () => `
  color: ${HEX_COLORS.electricCrimson};
`
);
